import { Component, Input, OnInit, inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

type Lang = 'it' | 'en' | 'fr';

@Component({
  selector: 'app-language-selector',
  standalone: true,
  imports: [NgbDropdownModule],
  templateUrl: './language-selector.component.html',
  styleUrl: './language-selector.component.scss'
})
export class LanguageSelectorComponent implements OnInit {
  private readonly translocoService = inject(TranslocoService);

  private static readonly SUPPORTED: readonly Lang[] = ['it', 'en', 'fr'] as const;
  protected activeLang: Lang = 'it';
  @Input() showLabel: boolean = true;
  @Input() mode: 'inline' | 'dropdown' = 'inline';
  @Input() menuAlign: 'start' | 'end' = 'end';

  protected get activeFlagSrc(): string {
    const map: Record<Lang, string> = {
      it: 'assets/images/icons/flags/it.svg',
      en: 'assets/images/icons/flags/gb.svg',
      fr: 'assets/images/icons/flags/fr.svg',
    };
    return map[this.activeLang];
  }

  protected get activeFlagAlt(): string {
    const map: Record<Lang, string> = { it: 'Italiano', en: 'English', fr: 'Français' };
    return map[this.activeLang];
  }

  ngOnInit(): void {
    // Initialize from current or saved language, restricting to 'it' | 'en' | 'fr'
    try {
      const current = this.translocoService.getActiveLang();
      const saved = localStorage.getItem('lang');
      let preferred: Lang = 'it';
      if (saved && LanguageSelectorComponent.SUPPORTED.includes(saved as Lang)) {
        preferred = saved as Lang;
      } else if (LanguageSelectorComponent.SUPPORTED.includes(current as Lang)) {
        preferred = current as Lang;
      }
      this.translocoService.setActiveLang(preferred);
      this.activeLang = preferred;
    } catch {
      this.translocoService.setActiveLang('it');
      this.activeLang = 'it';
    }
  }

  protected onLanguageChange(lang: string): void {
    if (!lang || lang === this.translocoService.getActiveLang()) {
      return;
    }
    if (!LanguageSelectorComponent.SUPPORTED.includes(lang as Lang)) {
      return; // ignore unsupported values
    }
    this.translocoService.setActiveLang(lang);
    this.activeLang = lang as Lang;
    try {
      localStorage.setItem('lang', lang);
    } catch {}
  }
}
